module.exports = __webpack_public_path__ + "img/Thirteenth.b15ec88d.png";